import { createStorefrontApiClient } from '@shopify/storefront-api-client'

let _client: ReturnType<typeof createStorefrontApiClient> | null = null

export function getStorefrontClient() {
  if (_client) return _client
  const raw = (import.meta.env.VITE_SHOPIFY_DOMAIN as string | undefined)?.trim()
  const accessToken = (import.meta.env.VITE_SHOPIFY_STOREFRONT_TOKEN as string | undefined)?.trim()
  if (!raw || !accessToken) {
    throw new Error('[shop] VITE_SHOPIFY_DOMAIN and VITE_SHOPIFY_STOREFRONT_TOKEN must be set')
  }
  const storeDomain = raw.startsWith('http') ? raw : `https://${raw}`
  const apiVersion = (import.meta.env.VITE_SHOPIFY_API_VERSION as string | undefined) ?? '2026-04'
  _client = createStorefrontApiClient({ storeDomain, apiVersion, publicAccessToken: accessToken })
  return _client
}
